import React from "react";
import { Button } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from "prop-types";
import { ratings } from '../../../utils/KanbanMapper';
import { ExpandMoreRounded } from "@material-ui/icons";

const KanbanRatingDropdown = (props) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const updateCurrentRating = (rating) => {
    setAnchorEl(null);
    props.updateRating(rating);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        size="small"
        className={"kanban is-rating-button is-rating-button-" + ratings[props.rating] + "-active"}
        style={{ fontWeight: '800', margin: '4px 0px', width: '60px', boxShadow: 'none', borderRadius: '10px' }}
        endIcon={<ExpandMoreRounded />}
      >
        {ratings[props.rating] == 'x' ? '-' : ratings[props.rating].toUpperCase()}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {ratings.map((r, index) => {
          return (
            <MenuItem
              id={index}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                updateCurrentRating(index)
              }}
            >
              {r == 'x' ? '-' : r.toUpperCase()}
            </MenuItem>);
        })}
      </Menu>
    </div>
  );
}

KanbanRatingDropdown.propTypes = {
  rating: PropTypes.number,
  updateRating: PropTypes.func
};

export default KanbanRatingDropdown;